import type { EntityState, EntityId, EntityAdapter } from "@reduxjs/toolkit"
import { current } from "@reduxjs/toolkit"

type SnapshotSlice<T, Id extends EntityId> = EntityState<T, Id> & {
  snapshot: EntityState<T, Id>
}

export function snapshotSlice<T, Id extends EntityId>(
  state: SnapshotSlice<T, Id>,
) {
  state.snapshot.entities = current(state.entities)
  state.snapshot.ids = current(state.ids)
}

export function createRestoreSnapshot<T, Id extends EntityId>(
  adapter: EntityAdapter<T, Id>,
) {
  return (state: SnapshotSlice<T, Id>) => ({
    ...state.snapshot,
    snapshot: adapter.getInitialState(),
  })
}
